import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Building2,
  Users,
  UserRound,
} from "lucide-react";

const AdminSidebar = () => {
  const menuItems = [
    {
      label: "Dashboard",
      path: "/mainAdmin/home",
      icon: LayoutDashboard,
    },
    {
      label: "Properties",
      path: "/mainAdmin/properties",
      icon: Building2,
    },
    {
      label: "Investors",
      path: "/mainAdmin/investors",
      icon: Users,
    },
    {
      label: "Property Owners",
      path: "/mainAdmin/owners",
      icon: UserRound,
    },
  ];

  return (
    <aside className="fixed left-0 top-0 z-40 flex h-screen w-[165px] flex-col border-r border-[#dfe3e8] bg-white">

      {/* Logo */}
      <div className="flex h-[57px] items-center border-b border-[#e5e7eb] px-3">
        <div className="flex items-center gap-2">
          <div className="flex h-[22px] w-[22px] items-center justify-center rounded-[5px] bg-[#285ce7] text-[8px] font-bold text-white">
            PV
          </div>

          <div>
            <p className="text-[11px] font-semibold leading-none text-[#162b3a]">
              PropVault
            </p>

            <p className="mt-[3px] text-[7px] text-[#8d98a3]">
              Admin Console
            </p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-2 py-3">
        {menuItems.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `mb-1 flex h-[31px] items-center gap-2 rounded-[6px] px-2.5 text-[10px] transition ${
                  isActive
                    ? "bg-[#eaf2ff] font-medium text-[#1e5eff]"
                    : "text-[#334155] hover:bg-[#f5f7fa]"
                }`
              }
            >
              <Icon size={12} strokeWidth={1.7} />
              {item.label}
            </NavLink>
          );
        })}
      </nav>

      {/* Admin Profile */}
      <div className="border-t border-[#e5e7eb] p-3">
        <div className="flex items-center gap-2 rounded-[6px] bg-[#fafbfc] p-2">
          <div className="flex h-[24px] w-[24px] items-center justify-center rounded-full bg-[#dce9ff] text-[8px] font-medium text-[#285ce7]">
            SA
          </div>

          <div className="min-w-0">
            <p className="truncate text-[9px] font-medium text-[#1f2937]">
              Super Admin
            </p>

            <p className="truncate text-[7px] text-[#9aa3ad]">
              admin@propvault.ae
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default AdminSidebar;